import React, { Component } from 'react';

class SignButton extends Component {
  scrollToAnchor = () => {
    this.props.scrollId && document.getElementById(this.props.scrollId).scrollIntoView();
  }
  render() {
    return (
      <div className="sign-fix-button">
        <img className="sign-fix-button-img" src={ this.props.isCourse ? "https://static-image.xfz.cn/form-course-recommend.png" : "https://static-image.xfz.cn/form-sign-fix-button.png"} onClick={ this.scrollToAnchor }></img>
      </div>
    )
  }
}

export default SignButton;
